import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class FactoryService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of factories.
     *
     * @datatask 2024
     * @datataskName sp_ws_p2_factory_selectlist
     * @returns promise containing list of factories.
     */
    public getFactories(params?: Partial<GetFactoriesParams>): Promise<FactoryItem[]> {
        return this.datatask.Post(2024, params);
    }
}

export interface GetFactoriesParams {
    businessco_no: string | number;
}

export interface FactoryItem {
    factory_id: string;
    factory_name: string;
    orderby: string;
}
